export default Object.freeze({
  CZK: 'Kč',
  EUR: '€',
});
